module.exports = __webpack_public_path__ + "img/connect-secure.b85fd476.svg";